module.exports = __webpack_public_path__ + "images/emoji/clock6.1be0490c06fb38ddf120.png";